import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

import { ProductType } from 'apiTyped/hooks/notebooks';

const ToggleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: white;
  border-radius: 24px;
  padding: 4px;
  gap: 4px;
`;

const ToggleButton = styled.button<{ active: boolean }>`
  padding: 3px 10px;
  border: none;
  border-radius: 20px;
  min-width: 82px;
  font-family: Oswald, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  background-color: ${(props) =>
    props.active ? props.theme.colors['terra-cotta'] : 'transparent'};
  color: ${(props) =>
    props.active ? 'white' : props.theme.colors['cool-grey']};

  &:hover {
    background-color: ${(props) =>
      props.active
        ? props.theme.colors['terra-cotta']
        : props.theme.colors['cool-grey']};
    color: white;
  }

  &:focus {
    outline: none;
  }
`;

type CategoryToggleProps = {
  value: ProductType;
  onChange: (value: ProductType) => void;
};

const CategoryToggle = ({ value, onChange }: CategoryToggleProps) => {
  const isWine = value === ProductType.Wine;
  const isSpirit = value === ProductType.Spirit;

  return (
    <ToggleContainer>
      <ToggleButton
        active={isWine}
        onClick={() => onChange(ProductType.Wine)}
        aria-pressed={isWine}
      >
        {I18n.t('notebooks.filters.categories.wine')}
      </ToggleButton>
      <ToggleButton
        active={isSpirit}
        onClick={() => onChange(ProductType.Spirit)}
        aria-pressed={isSpirit}
      >
        {I18n.t('notebooks.filters.categories.spirit')}
      </ToggleButton>
    </ToggleContainer>
  );
};

export default CategoryToggle;
